import { useEffect } from 'react';
import type { AnyAction } from '@reduxjs/toolkit';

import { useAppDispatch, useAppSelector } from 'hooks/redux';
import { handleTour } from 'store/slices/app';
import { getCookie } from 'helpers/cookie';
import { useToggle } from 'hooks/useToggle';
import { useBreakpoint } from 'hooks/useBreakpoint';

// Each design closes its own single-image download dropdown before the tour starts.
export const useDownloadTourModal = (closeSingleImageDownload: () => AnyAction) => {
  const dispatch = useAppDispatch();
  const { toggle: isOpened, openToggle: openModal, closeToggle: closeModal } = useToggle();
  const { imagesDownloaded } = useAppSelector((state) => state.app);
  const isDownloadTourNotStarted = getCookie('isDownloadTourFinished') !== 'true';
  const isTourEnabled = localStorage.getItem('downloadTourWasEnabled') === 'true';
  const isDesktop = useBreakpoint('mobile');

  const { isShareSite } = useAppSelector((state) => state.collection);

  const isTourShouldBeShown = imagesDownloaded >= 5 || (isTourEnabled && imagesDownloaded >= 1);

  useEffect(() => {
    if (isDownloadTourNotStarted && isTourShouldBeShown && !isShareSite) {
      openModal();
    }
  }, [isTourShouldBeShown, isShareSite]);

  const startTourDesktop = () => {
    closeModal();

    setTimeout(() => {
      document.querySelector('[data-scroll="image-effect-scroll"]')?.scrollIntoView();
    }, 400);

    // Timeout to provide some more time for tour to mount after scrolling
    setTimeout(() => {
      dispatch(handleTour('downloadTour'));
      dispatch(closeSingleImageDownload());
    }, 450);
  };

  const startTourMobile = () => {
    closeModal();
    dispatch(handleTour('downloadTour'));
    dispatch(closeSingleImageDownload());
  };

  return {
    isOpened,
    closeModal,
    startTour: isDesktop ? startTourDesktop : startTourMobile
  };
};
